import CampaignTranslations from './Wrapper.vue'

export default CampaignTranslations
